import { formatarValor } from "./OrderTable";

const TaxesSimulations = ({
  iiFromApi,
  ipipasepFromApi,
  pisFromApi,
  cofinsFromApi,
  icmsFromApi,
  afrmmFromApi,
  otherShippingExpenses,
  storageValue,
  customClearanceValue,
  otherExpensesValue,
  freightCollectValue,
}) => {
  const sections = [
    {
      title: null,
      items: ["II", "IPI", "PIS", "COFINS", "ICMS", "AFRMM"],
    },
    {
      title: "PREVISTO",
      items: [
        formatarValor(iiFromApi, "USD"),
        formatarValor(ipipasepFromApi, "USD"),
        formatarValor(pisFromApi, "USD"),
        formatarValor(cofinsFromApi, "USD"),
        formatarValor(icmsFromApi, "USD"),
        formatarValor(afrmmFromApi, "USD"),
      ],
    },
    {
      title: null,
      items: [
        "OUTRAS DESPESAS DE FRETE",
        "ARMAZENAGEM",
        "DESEMBARAÇO ADUANEIRO",
        "OUTRAS DESPESAS",
        "COLLECT DE FRETE",
      ],
    },
    {
      title: "PREVISTO",
      items: [
        formatarValor(otherShippingExpenses, "USD"),
        formatarValor(storageValue, "USD"),
        formatarValor(customClearanceValue, "USD"),
        formatarValor(otherExpensesValue, "USD"),
        formatarValor(freightCollectValue, "USD"),
      ],
    },
  ];

  const handleInputChange = (e, setState) => {
    setState(e.target.value);
  };

  return (
    <div className="bg-[#F2F2F2] w-full h-[605px] rounded-2xl my-24 px-14 py-[53px] grid grid-cols-4 justify-center items-center">
      {sections.map((section, index) => (
        <div key={index} className="flex flex-col gap-4">
          {section.title !== null ? (
            <p className="font-bold text-[#FF9533] text-center">
              {section.title}
            </p>
          ) : (
            <div className="h-[1rem]" />
          )}
          {section.items.map((item, itemIndex) => {
            let setState;

            return (
              <input
                type="text"
                className={`max-w-[185px] min-h-[55px] text-sm rounded text-center self-center ${
                  section.title === null
                    ? "bg-transparent font-bold cursor-default focus:outline-none truncate"
                    : "bg-[#E8E9EB]"
                }`}
                key={itemIndex}
                value={item}
                onChange={(e) => handleInputChange(e, setState)}
                readOnly={section.title === "PREVISTO"}
              />
            );
          })}
        </div>
      ))}
    </div>
  );
};

export default TaxesSimulations;
